/* unplugin-vue-components disabled */import script from "./projectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./projectCard.vue?vue&type=script&setup=true&lang=js"

import "./projectCard.vue?vue&type=style&index=0&id=2234bbaa&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2234bbaa"]])

export default __exports__